<template>
  <main class="retoure-und-kuendigung">
    <SingleLevelBreadcrumb label="Lieferstatus & Retoure" />
    <div class="grid grid--center">
      <div class="grid__item grid__item-12 grid__item--spacing-2">
        <Heading
          spaces-bottom
          class="text--center"
        >
          Lieferstatus & Retoure
        </Heading>
        <Paragraph class="text text--center">
          Du möchtest Dich über den Lieferstatus Deiner bestellten Produkte informieren?<br />Bitte
          wähle dazu, über welche Produkte Du Dich informieren möchtest!
        </Paragraph>
      </div>
      <TabGroup
        :tabs="tabsData"
        :class="'grid__item grid__item--12'"
      >
        <TabGroupEntry
          slot="retoure"
          class="grid grid--center"
        >
          <div class="grid__item grid__item--8">
            <div class="grid grid--center">
              <TextImage
                v-for="(retoure, i) in textImageData.retoure"
                :key="i"
                :text-image-data="retoure"
                class="grid__item grid__item-12 grid__item--m-6 grid__item--l-5"
              />
            </div>
          </div>
        </TabGroupEntry>
        <TabGroupEntry
          slot="lieferstatus"
          class="grid grid--center"
        >
          <div class="grid__item grid__item--8">
            <div class="grid grid--center">
              <TextImage
                v-for="(retoure, i) in textImageData.lieferstatus"
                :key="i"
                :text-image-data="retoure"
                class="grid__item grid__item-12 grid__item--m-6 grid__item--l-5"
              />
            </div>
          </div>
        </TabGroupEntry>
      </TabGroup>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import SingleLevelBreadcrumb from '~/components/single-level-breadcrumb.vue';
import TabGroup from '@/components/tab-group.vue';
import TabGroupEntry from '@/components/tab-group-entry.vue';
import TextImage from '@/components/text-image.vue';
import { Heading, Paragraph } from '@i22-td-smarthome/component-library';
import { Track } from '~/helpers/page-tracking';
import { getHeader } from '~/helpers/page-header-compositon';

const tabsData = [
  {
    name: 'lieferstatus',
    label: 'Lieferstatus',
  },
  {
    name: 'retoure',
    label: 'Retoure',
  },
];

const textImageData = {
  retoure: [
    {
      theme: 'dark',
      align: 'center',
      imgPosition: 'top',
      srcSmall:
        '/content/content-images/lieferstatus-retoure/retoure/e52539d1c154fc00308c968aed755377/retoure-retoure.png',
      altText: 'Retoure',
      content:
        '<p>Produkte der <strong>Telekom Deutschland GmbH</strong></p>\n<p><a href="https://retoure.telekom-dienste.de/fernabsatz" target="_blank" rel="noopener" class="btn btn--inline btn--default" data-tealium-rel="content.button.retoure-anmelden">Retoure Anmelden</a></p>',
    },
    {
      theme: 'dark',
      align: 'center',
      imgPosition: 'top',
      srcSmall:
        '/content/content-images/lieferstatus-retoure/retoure/e52539d1c154fc00308c968aed755377/retoure-retoure.png',
      flipX: true,
      altText: 'Retoure',
      content:
        '<p>Produkte der <strong>Brodos AG</strong></p>\n<p><a href="https://service.brodos.net/retoure" target="_blank" rel="noopener" class="btn btn--inline btn--default" data-tealium-rel="content.button.retoure-anmelden">Retoure Anmelden</a></p>',
    },
  ],
  lieferstatus: [
    {
      theme: 'dark',
      align: 'center',
      imgPosition: 'top',
      srcSmall:
        '/content/content-images/lieferstatus-retoure/retoure/e52539d1c154fc00308c968aed755377/retoure-retoure.png',
      altText: 'Retoure',
      content:
        '<p>Produkte der <strong>Telekom Deutschland GmbH</strong></p>\n<p><a href="https://www.telekom.de/unterwegs/lieferstatus" target="_blank" rel="noopener" class="btn btn--inline btn--default" data-tealium-rel="content.button.lieferstatus">Lieferstatus</a></p>',
    },
    {
      theme: 'dark',
      align: 'center',
      imgPosition: 'top',
      srcSmall:
        '/content/content-images/lieferstatus-retoure/retoure/e52539d1c154fc00308c968aed755377/retoure-retoure.png',
      flipX: true,
      altText: 'Retoure',
      content:
        '<p>Produkte der <strong>Brodos AG</strong></p>\n<p><a href="mailto:telekom-onlineshop-service@brodos.de" target="_blank" rel="noopener" class="btn btn--inline btn--default" data-tealium-rel="content.button.email-an-den-kundenservice">E-Mail an den Kundenservice</a></p>',
    },
  ],
};

Track({ page_type: 'theme.solution' });

getHeader({
  title: ref('Lieferstatus und Retoure'),
  description: ref(
    'Du möchtest Dich über den Lieferstatus Deiner bestellten Produkte informieren? Bitte wähle dazu, über welche Produkte Du Dich informieren möchtest!'
  ),
  ogImage: ref(
    '/content/content-images/lieferstatus-retoure/retoure/e52539d1c154fc00308c968aed755377/retoure-retoure.png'
  ),
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.retoure-und-kuendigung {
  h1 {
    margin-top: 2.5 * $grid-base;
  }

  .tab-group {
    .text-image__image {
      img {
        display: inline-block;
      }
    }
  }
}
</style>
